import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Card,
  CardMedia,
  CardBody,
  CardTitle,
  CardActions,
  Button
} from '@one-thd/sui-atomic-components';
import { useDataModel } from '@thd-nucleus/data-sources';
import { emtContentDataModel } from '../dataModels';

// eslint-disable-next-line react/require-default-props
const IdeasCarousel = ({ contentId, pageName, sectionTitle }) => {
  const { loading, data, error } = useDataModel(
    'emtContent',
    {
      variables: {
        contentId,
        pageName
      }
    });

  const regionalLinks = data?.emtContent?.content?.gardenCenterArticles?.regional_links;

  if (!data || loading || error || !regionalLinks || regionalLinks?.length === 0) {
    return null;
  }

  return (
    <div className="sui-flex sui-flex-col sui-gap-3" data-component="IdeasCarousel">
      <Typography variant="h2">{sectionTitle}</Typography>
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-3 sui-gap-4">
        {regionalLinks.map(({ url, title, description, img }) => (
          <Card key={title}>
            <CardMedia src={img} alt={title} aspect="wide" />
            <CardTitle header={(
              <a href={url} className="hover:sui-underline sui-text-inherit sui-no-underline">
                {title}
              </a>
            )}
            />
            <CardBody>
              <Typography>{description}</Typography>
            </CardBody>
            <CardActions>
              <a
                href={url}
                className="hover:sui-no-underline"
              >
                <Button fullWidth variant="text">
                  Read More
                </Button>
              </a>
            </CardActions>
          </Card>
        ))}
      </div>
    </div>
  );
};

IdeasCarousel.propTypes = {
  contentId: PropTypes.string.isRequired,
  pageName: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string
};

IdeasCarousel.defaultProps = {
  sectionTitle: ''
};

IdeasCarousel.dataModel = emtContentDataModel;

IdeasCarousel.displayName = 'IdeasCarousel';

export default IdeasCarousel;
